const FORM_GENERATOR = {
  WORKING_HOURS: 'فرم ساعات کاری',
  FORM_GENERATOR_DESC:
    'طراحی فرم اطلاعات آغاز مکالمه بر اساس نیازهای خودتان. یا جمع‌آوری لیدهای خود با استفاده از رایچت.',
  NON_WORKING_HOURS: 'فرم ساعات غیر کاری',
  FORM_GENERATOR_BTN_RELEASE: 'انتشار',
  FORM_GENERATOR_TITLE_PAGE: 'صفحه ایجاد فرم ساعات کاری و غیر کاری',
  FORM_GENERATOR_NECESSARY_INFO: 'اجباری بودن دریافت اطلاعات',
  FORM_GENERATOR_FIRST_MSG: 'ارسال فرم قبل از ارسال اولین پیام',
  FORM_GENERATOR_TITLE_INPUT: 'عنوان فرم',
  FORM_GENERATOR_USER_MANUAL:
    'برای اعمال تغییرات دکمه انتشار در انتهای صفحه را فشار دهید.',
  FORM_GENERATOR_ACTIVE_FORM: 'فعال',
  FORM_GENERATOR_INACTIVE_FORM: 'غیر فعال',
  ERROR_MESSAGE: 'پر کردن فرم اضافه شده ضروری می‌باشد!',
  TITLE_ERROR_MESSAGE: 'نوشتن عنوان فرم ضروری می‌باشد!',
  FORM_NECESSARY: 'افزودن فرم ضروری می‌باشد!',
};

export default FORM_GENERATOR;
